const viewBodySidebarTpl = (resourceType, viewBodySidebarData) => {
  let html = "";

  switch (resourceType) {
    case "date":
      html += `<ul>${(function (data) {
        return data
          .map((date) => {
            return `<li data-resource-id="${date.toLocaleDateString()}"><span>${date.toLocaleString("pl-PL", {
              dateStyle: "short",
            })}</span></li>`;
          })
          .join("");
      })(viewBodySidebarData)}</ul>`;
      break;

    case "area":
      html += `<ul>${(function (data) {
        let html = "";

        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const resource = data[key];

            html += `<li data-resource-id="${resource.id}" title="${resource.title}"><span>${resource.title}</span></li>`;
          }
        }

        return html;
      })(viewBodySidebarData)}</ul>`;
      break;

    default:
      break;
  }

  return html;
};

export { viewBodySidebarTpl };
